.tableContainer {
    width: 100%;
}

/* --- Filters --- */
.filtersContainer {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    margin-bottom: 16px;
    justify-content: flex-end;
}

.filterStandardWidth {
    width: 270px;
}

.filterLargeWidth {
    width: 350px;
}

/* --- Expandable rows --- */
.expandIcon {
    background-color: transparent;
    padding: 6px 12px;
    border: none;
    cursor: pointer;
}

.expandIconBlue {
    color: var(--hps-blue);
}

.expandIconWhite {
    color: white;
}

.expandIconDown {
    -moz-transform: rotate(90deg);
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg);
    -moz-transition: all 0.25s linear;
    -webkit-transition: all 0.25s linear;
    transition: all 0.25s linear;
}

.expandIconRight {
    -moz-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
    -moz-transition: all 0.25s linear;
    -webkit-transition: all 0.25s linear;
    transition: all 0.25s linear;
}

.parentCell {
    border-bottom: unset !important;
}

.childCell {
    padding-top: 0px !important;
    padding-bottom: 0px !important;
}

/* --- Specific cell types --- */
.primaryTextAndSecondaryText {
    display: flex;
    flex-direction: column;
}

.textAndIconContainer {
    display: flex;
    gap: 8px;
    align-items: center;
}